import Module from './Module';

class TypeModule extends Module {
  constructor() {
    super('types', '/api/v1/types', true);
  }

  reducer(state = this.initialState, action) {
    const { GET_BY_ID, SAVE } = this.actionTypes;
    const { payload } = action;
    const data = payload && payload.data ? payload.data.data : null;

    switch (action.type) {
      case `${GET_BY_ID}_FULFILLED`:
        return { ...state, isLoading: false, edited: data, error: null };

      case `${SAVE}_FULFILLED`:
        return { ...state, isLoading: false, edited: data, error: null, successSave: true };

      default:
        return super.reducer(state, action);
    }
  }
}

const module = new TypeModule();

export const {
  get, getById, save, remove, resetState, resetSuccessSave,
} = module;

export default module.reducer;

/*import Module from './Module';

const module = new Module('types', '/api/v1/types');

export const {
  get, getById, save, remove, resetState, resetSuccessSave,
} = module;

export default module.reducer;*/



// WEBPACK FOOTER //
// ./src/modules/types.js